import {AlertType} from '../../reducers/alerts.reducer';
import {AlertProps} from '../../components/index';
import {Affiliate} from '../../../shared/types';
import {ConfigState} from '../../reducers/config';
import {TaxState} from '../../reducers/tax';
import {RouteComponentProps} from 'react-router-dom';

export interface GetAlertProps {
    affiliateAccount: Affiliate;
    configState: ConfigState;
    taxState: Partial<TaxState>;
    history: RouteComponentProps['history'];
    traceSecurityLink: VoidFunction;
}

export enum AlertComponentType {
    HIDE_WARNING_BAR = 'HIDE_WARNING_BAR',
    HIDE_POPUP = 'HIDE_POPUP'
}

export interface MessageCode {
    code: string;
    args?: any[];
}

export interface AlertItemProps extends Omit<AlertProps, 'message' | 'type'> {
    type?: AlertType;
    msgCodes: MessageCode[];
}
